import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchCurrencies = createAsyncThunk(
    'currency/fetchCurrencies',
    async () => {
        const response = await axios.get('/api/currencies');
        return response.data;
    }
);

const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currencySymbol: "$",
        currencyName: "MXN",
        currencyRate: 1,
        currencyCode: "MXN",
        locale: "es-MX",
        availableCurrencies: [],
        status: 'idle'
    },
    reducers: {
        setCurrency(state, action) {
            const currencyCode = action.payload;
            const currency = state.availableCurrencies.find(c => c.code === currencyCode);

            if (currency) {
                state.currencyName = currency.code;
                state.currencyCode = currency.code;
                state.currencySymbol = currency.symbol;
                state.currencyRate = currency.exchange_rate;
                
                // Locale logic
                if (currencyCode === "USD") state.locale = "en-US";
                else if (currencyCode === "EUR") state.locale = "es-ES";
                else state.locale = "es-MX";
            } else {
                // Fallback for hardcoded if list not loaded yet
                 if (currencyCode === "USD") {
                    state.currencySymbol = "$";
                    state.currencyRate = 0.054;
                    state.currencyName = "USD";
                    state.currencyCode = "USD";
                    state.locale = "en-US";
                } else if (currencyCode === "EUR") {
                    state.currencySymbol = "€";
                    state.currencyRate = 0.050;
                    state.currencyName = "EUR";
                    state.currencyCode = "EUR";
                    state.locale = "es-ES";
                } else if (currencyCode === "MXN") {
                    state.currencySymbol = "$";
                    state.currencyRate = 1;
                    state.currencyName = "MXN";
                    state.currencyCode = "MXN";
                    state.locale = "es-MX";
                }
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCurrencies.fulfilled, (state, action) => {
                state.availableCurrencies = Array.isArray(action.payload) ? action.payload : [];
                state.status = 'succeeded';
                
                // Update current currency rate if it exists in the new list
                const currentInList = Array.isArray(action.payload) ? action.payload.find(c => c.code === state.currencyCode) : null;
                if (currentInList) {
                    state.currencyRate = currentInList.exchange_rate;
                    state.currencySymbol = currentInList.symbol;
                }
            });
    }
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;

